import { Point } from 'app/contracts/Geometry';

/** https://stackoverflow.com/questions/8515900/how-to-constrain-movement-within-the-area-of-a-circle */
export class DistanceBetweenTwoPoints {
	public measure(p1: Point, p2: Point): number {
		return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
	}
}
